/** `ez.t.item_created_in_group` — *When an item is created in {this group, groupId}* (recipe 151). */
import { z } from 'zod';
import { defineTrigger } from '../block.js';
export const itemCreatedInGroupParams = z.object({ groupId: z.string().min(1) });
export const itemCreatedInGroupTrigger = defineTrigger({
    id: 'ez.t.item_created_in_group',
    kind: 'trigger',
    app: 'monday',
    sentencePartial: 'When an item is created in {this group, groupId}',
    paramsSchema: itemCreatedInGroupParams,
    subscribes: ['item.created'],
    assumed: true,
    references: (params) => [{ kind: 'group', id: params.groupId }],
    matches: (event, params) => event.payload.groupId === params.groupId,
    outputs: (event) => ({ itemId: event.itemId, boardId: event.boardId, groupId: event.payload.groupId, userId: event.payload.createdBy ?? event.actorId }),
});
//# sourceMappingURL=ez.t.item-created-in-group.js.map